// extracted by mini-css-extract-plugin
module.exports = {"root":"resultItem_root__C7mqV","icon":"resultItem_icon__1phaA","heading":"resultItem_heading__jqlzl","content":"resultItem_content__2X8As","infoIcon":"resultItem_infoIcon__b0XgY"};